var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Events Listing")]),_vm._l((_vm.events),function(event){return _c('EventCard',{key:event.id,attrs:{"event":event}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }